import styled from 'styled-components/native'

export const BannerContainer = styled.View`
  background-color: ${({ theme }) => theme.colors.bannerBg};
  border-radius: ${({ theme }) => theme.metrics.baseMargin}px;
  padding: ${({ theme }) => theme.metrics.baseMargin}px;
  margin: ${({ theme }) => theme.metrics.baseMargin * 1.5}px;
  flex-direction: row;
  align-items: flex-start;
  gap: ${({ theme }) => theme.metrics.baseMargin * 0.75}px;
`

export const TextContent = styled.View`
  flex: 1;
  gap: ${({ theme }) => theme.metrics.baseMargin / 2}px;
`
